import { EXECUTION_OUTCOME_TYPE } from 'interfaces/enums';

export const EXECUTION_OUTCOME_LABEL_KEY: Record<EXECUTION_OUTCOME_TYPE, string> = {
  [EXECUTION_OUTCOME_TYPE.NOTIFICATION]: 'dunning-forecast.notifications',
  [EXECUTION_OUTCOME_TYPE.DISCONNECTION_THREAT]: 'dunning-forecast.disconnection-threats',
  [EXECUTION_OUTCOME_TYPE.DISCONNECTION_ANNOUNCEMENT]: 'dunning-forecast.disconnection-announcements',
  [EXECUTION_OUTCOME_TYPE.DISCONNECTION]: 'dunning-forecast.disconnections',
  [EXECUTION_OUTCOME_TYPE.CONTRACT_TERMINATION]: 'dunning-forecast.terminations',
  [EXECUTION_OUTCOME_TYPE.DEBT_COLLECTION]: 'dunning-forecast.debt-collection',
  [EXECUTION_OUTCOME_TYPE.CANCEL_DEBT_COLLECTION]: 'dunning-forecast.cancel-debt-collection',
  [EXECUTION_OUTCOME_TYPE.CHANGE_OF_LEVEL]: 'dunning-forecast.change-of-level',
};
